<template>
  <div aria-hidden="true" class="onboarding-modal modal fade animated show" id="onboardingWideFormModal" role="dialog" tabindex="-1" style="display: block;">
    <div class="modal-dialog modal-lg modal-centered" role="document">
      <div class="modal-content">
        <div class="modal-header"><h5 class="modal-title" id="exampleModalLabel">Product Movement</h5><button aria-label="Close" class="close" @click="closeModal" type="button"><span aria-hidden="true"> ×</span></button></div>
        <Error v-if="state == 'error'" />
        <Loader v-if="state == 'loading'" :type="'modal'"/>
        <div class="modal-body" v-if="state == 'ready'">
                <div class="table-responsive">
                    <table class="table table-striped table-lightborder">
                        <thead>
                            <tr>
                                <th>Location</th>
                                <th>Added By</th>
                                <th>Checkin</th>
                                <th>Checkout</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="location in productHistory.locations">
                                <td>{{location.location}}</td>
                                <td>{{formatUser(location)}}</td>
                                <td>{{location.checkin_date}}</td>
                                <td>{{location.checkout_date}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from '@/components/common/Loader'
import Error from '@/components/common/Error'
export default {
  props: ['product', 'productHistory', 'state'],
  components: { Loader, Error },
  methods: {
    formatUser (location) {
      return (location.name == null ? 'System' : location.name)
    },
    closeModal: function () {
      this.$emit('modalInterface')
    }
  }
}
</script>
